module.exports = __webpack_public_path__ + "img/centennial - testimonial video - poster 3.3f98795b.jpg";